import React from "react";
import PageContainer from "publish/layout/PageContainer";
import Button from "../../../components/buttons";
import LayoutAside from "../LayoutAside";
import UIUtils from "utils/UIUtils";

function ContentsContainer() {
    const alertModal = async () => {
        console.log("alertModal");
        const value = await UIUtils.alert(<>
            <span className="fc-pri">*</span> 항목은 필수입력입니다.
        </>);
        console.log("alertModal", value);
    }

    const confirmModal = async () => {
        const value = await UIUtils.confirm(
            <p className="msg">
                png는 허용하지 않는 확장자입니다.<br/>
                허용 확장자: <span className="fc-pri">pdf</span>
            </p>
        );
        console.log("confirmModal", value);
    }

    return (
        <PageContainer session={false}>
            <LayoutAside />
            <div style={{padding: '40px', gap: '10px'}}>
                <Button color='gray-o' size="sm" onClick={alertModal}>Alert</Button><br/><br/>
                <Button color='gray-o' size="sm" onClick={confirmModal}>Confirm</Button><br/><br/>
            </div>
        </PageContainer>
    );
}
export default ContentsContainer;